import React, { useEffect, useRef, useState } from "react";
import * as Unicons from "@iconscout/react-unicons";

const SearchInput = ({
  initialValue,
  debouncedChange,
  placeholder = "Search ....",
  delay = 2000,
  currValueCb = () => {},
}) => {
  const [val, setVal] = useState(initialValue);
  const debouncedref = useRef(null);

  useEffect(() => {
    setVal(initialValue || "");
  }, [initialValue]);
  useEffect(() => {
    currValueCb && currValueCb(val);
    if (debouncedref.current) {
      clearTimeout(debouncedref.current);
    }
    const timer = setTimeout(() => {
      debouncedChange(val);
    }, delay);
    debouncedref.current = timer;
    return () => clearTimeout(timer);
  }, [val]);

  return (
    <div className="w-full relative">
      <button
        type="button"
        className="absolute top-[3px] left-0.5 p-2 text-sm rounded-r-lg bg-white"
      >
        <Unicons.UilSearch size="19" />
      </button>
      <input
        type="text"
        value={val}
        onChange={(e) => {
          // if (ProjectShowcase) {
          //   OnChangeSearchInput(e.target.value);
          //   setSearchInput(e.target.value);
          // } else {

          setVal(e.target.value);
          // }
        }}
        className="block pl-10 p-2.5 w-full z-20 text-sm bg-white rounded-lg  border border-gray-300 focus:border-gray-300 focus:ring-0"
        placeholder={placeholder}
        // required
        // autoComplete="off"
      />
    </div>
  );
};

export default SearchInput;
